import styled from "@emotion/styled";
import { Typography } from "@ecologi/react-components/src/Typography";
import { Button } from "@ecologi/react-components";

export const Wrapper = styled.div`
  padding: 24px 20px 64px 20px;
  @media ${(props) => props.theme.bp.tabletUp} {
    padding: 24px 20px 72px 20px;
  }
  @media ${(props) => props.theme.bp.wideDesktopUp} {
    padding: 24px 40px 96px 40px;
  }
  background-color: ${(props) => props.theme.colors.snowdrop};
`;

export const Title = styled(Typography)`
  font-size: 28px;
  line-height: 33px;
  margin-bottom: 24px;
  font-weight: 800;
  color: ${(props) => props.theme.colors.charcoal};

  @media ${(props) => props.theme.bp.tabletUp} {
    font-size: 32px;
    line-height: 39px;
    margin-bottom: 12px;
  }

  @media ${(props) => props.theme.bp.desktopUp} {
    margin-bottom: 32px;
  }
`;

export const ItemsList = styled.ul`
  padding: 0;
  margin: 0;
  margin-bottom: 22px;
  @media ${(props) => props.theme.bp.tabletUp} {
    margin-bottom: 30px;
  }
  display: flex;
  flex-direction: column;
`;

export const ProductImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 138px;
  width: 138px;
`;

export const CentredBadge = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 86px;
  height: 86px;
`;

export const ItemRow = styled.li`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  border-bottom: 2px solid ${(props) => props.theme.colors.mist};
  gap: 24px;

  @media ${(props) => props.theme.bp.desktopUp} {
    display: grid;
    margin: 0;
    grid-template-columns: 6fr 2fr 1fr 1fr;
    grid-gap: 12px;
    padding: 24px 0;
  }
`;

export const ItemName = styled(Typography)`
  margin-bottom: 20px;
  line-height: 100%;
  font-size: 18px !important;
`;

export const ItemContent = styled(Typography)`
  font-size: 14px !important;
  line-height: 20px;
  font-weight: 800 !important;
`;

export const HeaderRow = styled(ItemRow)`
  display: grid;
  margin-bottom: 8px;

  &:first-child {
    border-top: 0px;
    padding-top: 0px;
    padding-bottom: 8px;
  }
`;

export const ItemHeader = styled(Typography)`
  color: ${(props) => props.theme.colors.charcoal};
  font-size: 14px !important;
  line-height: 20px;
  white-space: nowrap;
`;

export const QuantityWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;

  @media ${(props) => props.theme.bp.desktopUp} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const UnitPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.bp.tabletUp} {
    margin: 0px;
  }

  @media ${(props) => props.theme.bp.desktopUp} {
    align-items: center;
    justify-content: flex-start;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${(props) => props.theme.bp.desktopUp} {
    max-width: 466px;
    align-items: flex-end;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
  @media ${(props) => props.theme.bp.tabletUp} {
    justify-content: flex-end;
  }
`;

export const Subtotal = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 36px;
  justify-content: space-between;
`;

export const ItemsTotal = styled.p`
  display: inline;
  font-weight: 400px;
  font-size: 12px;
  line-height: 16px;
`;

export const ProductDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;

  @media ${(props) => props.theme.bp.mobileUp} {
    align-items: flex-start;
    flex-direction: row;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    gap: 0;
  }
`;

export const ProductInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  @media ${(props) => props.theme.bp.tabletUp} {
    margin-left: 20px;
  }
`;

export const ProductInlineFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 18px;
`;

export const RemoveLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media ${(props) => props.theme.bp.tabletUp} {
    display: block;
  }
`;

export const ItemsNotAvailable = styled(Typography)`
  margin-top: 12px;
  font-weight: 400;
`;

export const FooterContent = styled(Typography)`
  font-size: 16px;
  line-height: 20px;
  font-weight: 800;
`;

export const ContinueButton = styled(Button)`
  margin-top: 24px;
`;

export const CheckoutButtonContainer = styled.div`
  display: inline-flex;
  margin-top: 32px;
  justify-content: flex-end;
  width: 100%;
`;

export const FundedByContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const PriceDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;

  > *:nth-child(2) {
    flex: 1;
  }
`;
